<template>
	<app>
		<c-form ref="form">
			<c-form-item v-model="userInfo.name" type="input" label="中标单位" required disabled></c-form-item>
			<c-form-item type="input" label="项目名称" name="name" required @change="validName"></c-form-item>
			<c-form-item type="select" label="所属行业" name="sshy" required options="INDUSTRY"></c-form-item>
			<c-form-item type="input" label="中标金额" name="zb_money" required input-word="元" decimal="2"></c-form-item>
			<c-form-item type="number" label="工期" name="sggq" input-word="天" required word="以合同工期为准，填写准确"></c-form-item>
			<c-form-item type="region" label="项目建设地址" province-name="province" city-name="city" county-name="district" address-name="address" required></c-form-item>
			<c-form-item v-model="currentYzdw" ref="yzdw" type="select" label="所属业主单位" name="yzdw_id" required options="OWNER_UNIT"></c-form-item>
			<c-form-item type="select" label="所属组织部门" name="yzdw_organization_id" required :options="departmentList"></c-form-item>
			<c-form-item type="input" label="业主单位联系人" name="yzdw_lxr"></c-form-item>
			<c-form-item type="input" label="业主单位联系电话" name="yzdw_lxdh"></c-form-item>
			<c-form-item type="input" label="被保险人" name="bbxr_name" required></c-form-item>
			<c-form-item type="input" label="被保险人组织代码" name="bbxr_jgdm" required></c-form-item>
			<c-form-item type="file" label="招标文件" name="files_path" required file-type="word,excel,pdf,zip,image"></c-form-item>
			<c-form-item type="file" label="中标通知书" name="zb_path" required file-word="可使用会议纪要代替" file-type="word,pdf,zip,image"></c-form-item>
			<c-form-item label="需购买保函" name="bx_type_ids" required>
				<c-checkbox-group v-model="currentInsurance">
					<c-checkbox v-for="(item, i) in insuranceType" :key="i" :value="item.value">{{item.name}}</c-checkbox>
				</c-checkbox-group>
			</c-form-item>
			<c-form-item type="textarea" label="备注说明" name="zb_remark"></c-form-item>
		</c-form>
		
		<div slot="button">
			<c-button size="m" @click="submitHandle">提交保存</c-button>
		</div>
	</app>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		data() {
			return {
				currentYzdw: '',
				insuranceType: [],
				currentInsurance: [],
				departmentList: []
			}
		},
		
		computed: {
			...mapState(['userInfo'])
		},
		
		watch: {
			currentYzdw(val) {
				this.$nextTick(() => {
					let yzdw = this.$refs.yzdw.$children[0].getCheckedOption();
					if (!yzdw || yzdw.value == -1) {
						this.$refs.form.set({
							bbxr_name: '',
							bbxr_jgdm: ''
						});
					} else {
						this.$refs.form.set({
							bbxr_name: yzdw.data.name,
							bbxr_jgdm: yzdw.data.yyzzh
						});
					}
				});
				this.request({
					url: '/yzdw/organization/selectList',
					data: {
						yzdw_id: val
					},
					success: data => {
						this.departmentList = Array.from(data, item => {
							return {
								name: item.organization_name,
								value: item.organization_id.toString()
							}
						});
						this.$nextTick(() => {
							this.$refs.form.set({
								yzdw_organization_id: ''
							});
						})
					}
				});
			}
		},
		
		mounted() {
			this.request({
				url: '/bx_type/list',
				success: data => {
					this.insuranceType = Array.from(data, item => {
						return {
							name: item.type_name,
							value: item.type_id
						}
					});
				}
			});
		},
		
		methods: {
			validName(name) {
				this.request({
					url: '/project/existsName',
					data: {
						project_id: 0,
						name
					},
					fail: () => {
						this.$refs.form.set({
							name: ''
						});
					}
				});
			},
			
			submitHandle() {
				this.$refs.form.submit({
					url: '/project/add',
					rule: {
						name: '请填写项目名称',
						sshy: '请选择所属行业',
						zb_money: '请填写中标金额',
						sggq: '请填写工期',
						district: '请选择项目建设地址',
						address: '请填写项目建设详细地址',
						yzdw_id: '请选择所属业主单位',
						yzdw_organization_id: '请选择所属组织部门',
						bbxr_name: '请填写被保险人',
						bbxr_jgdm: '请填写被保险人组织代码',
						files_path: '请上传招标文件',
						zb_path: '请上传中标通知书',
					},
					dataFormatter: data => {
						data.bx_type_ids = this.currentInsurance;
						return data;
					},
					success: () => {
						this.$message({
							text: '提交成功'
						});
						this.navigateBack();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
